// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2TgU_","inner":"Footer_inner__2FeNo","nextIcon":"Footer_nextIcon__2qlAy","innerLeft":"Footer_innerLeft__3y5s3"};